import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { appPlus16Icon } from '@icons/plus-16';

import { AiAssistantService } from '../../ai-assistant.service';
import { AiConversationListComponent } from '../ai-conversation-list/ai-conversation-list.component';

@Component({
  selector: 'app-ai-assistant-sidebar',
  imports: [SvgIconComponent, TranslatePipe, AiConversationListComponent],
  templateUrl: './ai-assistant-sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col lg:rounded-radius-primary lg:bg-background-fixed min-h-0' },
})
export class AiAssistantSidebarComponent {
  readonly #aiService = inject(AiAssistantService);

  public readonly conversationListVm = this.#aiService.conversationListVm;
  public readonly conversationsLoading = this.#aiService.conversationsLoading;
  public readonly conversationsHasMore = this.#aiService.conversationsHasMore;
  public readonly isNewChat = this.#aiService.isNewChat;

  /** Emits after navigation actions (new chat or conversation selected) so mobile overlay can close. */
  public readonly navigated = output<void>();

  constructor() {
    injectRegisterIcons([appPlus16Icon]);
  }

  public onNewChat(): void {
    this.#aiService.startNew();
    this.navigated.emit();
  }

  public onConversationSelected(): void {
    this.navigated.emit();
  }

  public onLoadMore(): void {
    this.#aiService.loadMoreConversations();
  }
}
